/* SHK-RC theme JS ─ v1.0
   Architecture mirrors the SHK Works approach: every behaviour is either
   (a) an idempotent init re-run on shopify:section:load, or
   (b) a document-level delegated handler that survives any re-render.
   Nothing here caches a node across a Section Rendering API swap. */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  var routes = (window.SHKRC && window.SHKRC.routes) || {
    cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update', root: '/'
  };
  if (!routes.cartUpdate) routes.cartUpdate = '/cart/update';

  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  function esc(s) { return String(s == null ? '' : s).replace(/[<>&"]/g, ''); }

  /* ================= RACER CODE =================
     Same three capture paths as the SHK Works creator code:
     1. ?ref=CODE links       → routed once through /discount/{code}
     2. Manual entry          → cart drawer, cart page, product page, popup
     3. Product-page property → rides inside the product form so Buy Now /
        Shop Pay (which skip the cart entirely) still carry the code. */
  function storedCode() {
    try { return (localStorage.getItem('shkrcRacerCode') || '').trim(); } catch (e) { return ''; }
  }
  function rememberCode(code) {
    try { localStorage.setItem('shkrcRacerCode', code); } catch (e) {}
  }
  function prefillCodes() {
    var code = storedCode();
    if (!code) return;
    document.querySelectorAll('[data-code-input], input[name="contact[Racer Code]"]').forEach(function (input) {
      if (input.value) return;
      input.value = code;
      var pdp = input.closest('[data-code-pdp]');
      if (pdp) pdp.setAttribute('open', '');
    });
  }
  (function captureRef() {
    if (DESIGN) return;
    var params = new URLSearchParams(window.location.search);
    var code = (params.get('ref') || params.get('racer') || '').trim();
    if (!code) return;
    rememberCode(code);
    var marker = null;
    try { marker = sessionStorage.getItem('shkrcRefApplied'); } catch (e) {}
    if (marker === code) return;
    try { sessionStorage.setItem('shkrcRefApplied', code); } catch (e) {}
    params.delete('ref');
    params.delete('racer');
    var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.location.replace('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(clean));
  })();

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-code-input], input[name="contact[Racer Code]"]');
    if (!input) return;
    var v = input.value.trim();
    if (v) rememberCode(v);
  });

  /* The PDP property input only carries a name while it holds a value, so no
     order ever gets a blank "Racer Code" line item property. */
  function syncCodeProperty() {
    document.querySelectorAll('[data-code-pdp] [data-code-input]').forEach(function (input) {
      if (input.value.trim()) input.setAttribute('name', 'properties[Racer Code]');
      else input.removeAttribute('name');
    });
  }
  document.addEventListener('input', function (e) {
    if (e.target.closest('[data-code-pdp] [data-code-input]')) syncCodeProperty();
  });

  /* ================= MOBILE MENU ================= */
  function closeMenu() {
    var sheet = document.querySelector('[data-menu-sheet]');
    var bar = document.querySelector('[data-topbar]');
    if (sheet) sheet.classList.remove('open');
    if (bar) {
      bar.classList.remove('is-open');
      var b = bar.querySelector('[data-menu-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) {
      var sheet = document.querySelector('[data-menu-sheet]');
      var bar = document.querySelector('[data-topbar]');
      if (!sheet) return;
      var open = !sheet.classList.contains('open');
      sheet.classList.toggle('open', open);
      if (bar) {
        bar.classList.toggle('is-open', open);
        var b = bar.querySelector('[data-menu-toggle]');
        if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      document.body.style.overflow = open ? 'hidden' : '';
      return;
    }
    if (e.target.closest('[data-menu-sheet] a')) closeMenu();
  });

  /* ================= ALERT BAR (session dismiss) ================= */
  (function () {
    var bar = document.querySelector('[data-alert]');
    if (!bar) return;
    var t = bar.querySelector('.alert-text');
    var key = 'shkrcAlert:' + (t ? t.textContent.trim().slice(0, 60) : '');
    try { if (sessionStorage.getItem(key) === '1') { bar.remove(); return; } } catch (e) {}
    bar.addEventListener('click', function (ev) {
      if (!ev.target.closest('[data-alert-close]')) return;
      bar.remove();
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
    });
  })();

  /* Referral confirmation, once per session */
  (function () {
    var code = storedCode();
    if (!code) return;
    var applied = null, shown = null;
    try {
      applied = sessionStorage.getItem('shkrcRefApplied');
      shown = sessionStorage.getItem('shkrcRefToast');
    } catch (e) { return; }
    if (applied !== code || shown === code) return;
    try { sessionStorage.setItem('shkrcRefToast', code); } catch (e) {}
    fireToast('CODE SAVED', 'RACER CODE ' + esc(code), '紹');
  })();

  /* ================= REVEAL ================= */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('on');
      io.unobserve(en.target);
    });
  }, { threshold: 0.1 });

  function reveal(scope) {
    (scope || document).querySelectorAll('.rv:not(.on)').forEach(function (el) {
      if (DESIGN) el.classList.add('on');
      else io.observe(el);
    });
  }

  /* ================= SECTION INITS ================= */
  function initMarquee(scope) {
    (scope || document).querySelectorAll('[data-marquee]:not([data-inited])').forEach(function (m) {
      m.dataset.inited = '1';
      m.innerHTML = m.innerHTML.repeat(4);
    });
  }

  function initStickyBuy(scope) {
    (scope || document).querySelectorAll('[data-sticky-buy]:not([data-inited])').forEach(function (bar) {
      bar.dataset.inited = '1';
      var anchor = document.querySelector('.buy-row');
      if (!anchor) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          bar.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      obs.observe(anchor);
    });
  }

  function initRelated(scope) {
    (scope || document).querySelectorAll('[data-related]:not([data-inited])').forEach(function (rel) {
      rel.dataset.inited = '1';
      if (!rel.dataset.url) return;
      fetch(rel.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-related]');
          if (fresh && fresh.innerHTML.trim().length) {
            rel.innerHTML = fresh.innerHTML;
            reveal(rel);
          } else if (!DESIGN) {
            rel.remove();
          }
        })
        .catch(function () { if (!DESIGN) rel.remove(); });
    });
  }

  function initAddressForms(scope) {
    (scope || document).querySelectorAll('[data-address-country]:not([data-inited])').forEach(function (countrySel) {
      countrySel.dataset.inited = '1';
      var wrap = countrySel.closest('form') || document;
      var provinceSel = wrap.querySelector('[data-address-province]');
      function sync() {
        if (!provinceSel) return;
        var opt = countrySel.selectedOptions[0];
        var raw = opt ? opt.getAttribute('data-provinces') : null;
        var list = [];
        try { list = raw ? JSON.parse(raw) : []; } catch (e) { list = []; }
        provinceSel.innerHTML = '';
        if (!list.length) { provinceSel.parentElement.style.display = 'none'; return; }
        provinceSel.parentElement.style.display = '';
        list.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0];
          o.textContent = p[1];
          provinceSel.appendChild(o);
        });
        if (provinceSel.dataset.default) provinceSel.value = provinceSel.dataset.default;
      }
      if (countrySel.dataset.default) countrySel.value = countrySel.dataset.default;
      countrySel.addEventListener('change', sync);
      sync();
    });
  }

  function initVariants(scope) {
    (scope || document).querySelectorAll('[data-variant-root]:not([data-inited])').forEach(function (root) {
      root.dataset.inited = '1';
      updateVariant(root);
    });
  }

  function initSection(scope) {
    initMarquee(scope);
    initStickyBuy(scope);
    initRelated(scope);
    initAddressForms(scope);
    initVariants(scope);
    reveal(scope);
  }

  initSection(document);

  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
  document.addEventListener('shopify:section:reorder', function () { reveal(document); });

  /* ================= TOAST ================= */
  function fireToast(title, sub, mark) {
    var t = document.querySelector('[data-toast]');
    if (!t) {
      t = document.createElement('div');
      t.className = 'toast';
      t.setAttribute('data-toast', '');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = '<span class="mk">' + esc(mark || '追') + '</span><div><b>' + esc(title) +
      '</b><small>' + esc(sub || '') + '</small></div>';
    clearTimeout(t._timer);
    requestAnimationFrame(function () { t.classList.add('show'); });
    t._timer = setTimeout(function () { t.classList.remove('show'); }, 2800);
  }

  /* ================= GALLERY FILTERS ================= */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-filters] .chip');
    if (!chip) return;
    var filters = chip.closest('[data-filters]');
    var root = filters.closest('.shopify-section') || document;
    var grid = root.querySelector('[data-rig-grid]');
    if (!grid) return;
    filters.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('sel'); });
    chip.classList.add('sel');
    var f = chip.dataset.f;
    grid.querySelectorAll('.rig').forEach(function (g) {
      var match = f === 'all' || g.dataset.cat === f;
      g.style.display = match ? '' : 'none';
      if (match) {
        g.classList.remove('on');
        void g.offsetWidth;
        g.classList.add('on');
      }
    });
  });

  /* ================= GENERIC TOGGLES / LOGIN PANELS ================= */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle-target]');
    if (!t) return;
    e.preventDefault();
    var el = document.querySelector(t.dataset.toggleTarget);
    if (el) el.style.display = el.style.display === 'none' ? '' : 'none';
  });
  document.addEventListener('click', function (e) {
    var recover = e.target.closest('[data-show-recover]');
    var login = e.target.closest('[data-show-login]');
    if (!recover && !login) return;
    e.preventDefault();
    var lp = document.getElementById('LoginPanel');
    var rp = document.getElementById('RecoverPanel');
    if (lp && rp) {
      lp.style.display = recover ? 'none' : '';
      rp.style.display = recover ? '' : 'none';
    }
  });
  if (window.location.hash === '#recover') {
    var rBtn = document.querySelector('[data-show-recover]');
    if (rBtn) rBtn.click();
  }

  /* ================= REFERENCE IMAGE UPLOADS =================
     Compressed in the browser, then carried inside the webhook JSON as
     base64. The Apps Script writes the files to Drive and drops the view
     links into the sheet row. Shopify's contact form can't carry
     attachments, so the email copy only lists filenames. */
  var imageStore = new WeakMap(); /* upload element → array of {name,type,dataUrl} */

  function imagesFor(upload) {
    if (!imageStore.has(upload)) imageStore.set(upload, []);
    return imageStore.get(upload);
  }

  function processImageFile(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var objUrl = URL.createObjectURL(file);
      img.onload = function () {
        try {
          var MAX = 1600;
          var scale = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(img.naturalWidth * scale);
          canvas.height = Math.round(img.naturalHeight * scale);
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          URL.revokeObjectURL(objUrl);
          resolve({
            name: file.name.replace(/\.[^.]+$/, '') + '.jpg',
            type: 'image/jpeg',
            dataUrl: canvas.toDataURL('image/jpeg', 0.8)
          });
        } catch (err) { reject(err); }
      };
      img.onerror = function () {
        /* Format the browser can't decode (some HEIC) — pass the original through
           when it's small enough to survive the request. */
        URL.revokeObjectURL(objUrl);
        if (file.size > 6 * 1024 * 1024) { reject(new Error('too large')); return; }
        var reader = new FileReader();
        reader.onload = function () { resolve({ name: file.name, type: file.type || 'image/jpeg', dataUrl: reader.result }); };
        reader.onerror = function () { reject(new Error('read failed')); };
        reader.readAsDataURL(file);
      };
      img.src = objUrl;
    });
  }

  function renderPreviews(upload) {
    var list = imagesFor(upload);
    var wrap = upload.querySelector('[data-up-previews]');
    var count = upload.querySelector('[data-up-count]');
    var max = upload.dataset.max || '3';
    if (!wrap) return;
    wrap.innerHTML = '';
    list.forEach(function (im, i) {
      var d = document.createElement('div');
      d.className = 'up-thumb';
      var pic = document.createElement('img');
      pic.src = im.dataUrl;
      pic.alt = im.name;
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'up-rm';
      x.setAttribute('data-up-remove', '');
      x.dataset.index = i;
      x.setAttribute('aria-label', 'Remove image');
      x.textContent = '×';
      d.appendChild(pic);
      d.appendChild(x);
      wrap.appendChild(d);
    });
    if (count) count.textContent = list.length ? '(' + list.length + '/' + max + ')' : '';
    if (list.length) {
      var err = upload.querySelector('[data-up-error]');
      if (err) err.classList.remove('show');
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-up-input]');
    if (!input) return;
    var upload = input.closest('[data-up]');
    if (!upload) return;
    var list = imagesFor(upload);
    var max = parseInt(upload.dataset.max || '3', 10);
    var files = Array.prototype.slice.call(input.files || []);
    input.value = '';
    files.forEach(function (file) {
      if (list.length >= max) return;
      if (!/^image\//.test(file.type) && file.type !== '') return;
      processImageFile(file)
        .then(function (im) {
          if (list.length >= max) return;
          list.push(im);
          renderPreviews(upload);
        })
        .catch(function () { alert('Could not add that image — too large or unsupported format.'); });
    });
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-up-remove]');
    if (!rm) return;
    var upload = rm.closest('[data-up]');
    if (!upload) return;
    imagesFor(upload).splice(parseInt(rm.dataset.index, 10), 1);
    renderPreviews(upload);
  });

  /* ================= WEBHOOK POST =================
     Plain fetch, not sendBeacon/keepalive: those cap at 64KB, far too small
     for image payloads. Awaited before any navigation, with a 14s timeout so
     a hung request never strands the customer on a dead button. */
  function postToSheet(url, payload) {
    var req;
    try {
      req = fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (err) {
      return Promise.resolve();
    }
    var timeout = new Promise(function (resolve) { setTimeout(resolve, 14000); });
    return Promise.race([req, timeout]);
  }

  function payloadFromForm(form) {
    var payload = {};
    new FormData(form).forEach(function (v, k) {
      var m = k.match(/^contact\[(.+)\]$/);
      if (m && String(v).trim()) payload[m[1]] = v;
    });
    return payload;
  }

  function collectSelections(scope) {
    scope.querySelectorAll('[data-field]').forEach(function (input) {
      var block = input.closest('.q-block');
      if (block && block.hidden) { input.value = ''; return; }
      var group = scope.querySelector('[data-q="' + input.dataset.field + '"]');
      if (!group) return;
      var values = [];
      group.querySelectorAll('.sel').forEach(function (el) {
        values.push(el.dataset.v || el.textContent.trim());
      });
      input.value = values.join(', ');
    });
  }

  /* Validates the shared contact block (email + phone + name + images).
     Returns true when everything required is present. */
  function validateContactBlock(scope) {
    var ok = true;
    var focusEl = null;

    scope.querySelectorAll('[data-required-text]').forEach(function (input) {
      var err = scope.querySelector('[data-error-for="' + input.dataset.requiredText + '"]');
      var bad = !input.value.trim();
      if (err) err.classList.toggle('show', bad);
      if (bad) { ok = false; focusEl = focusEl || input; }
    });

    var email = scope.querySelector('[data-email]');
    var emailErr = scope.querySelector('[data-email-error]');
    if (email) {
      var badEmail = !email.value.trim() || !email.checkValidity();
      if (emailErr) emailErr.classList.toggle('show', badEmail);
      if (badEmail) { ok = false; focusEl = focusEl || email; }
    }

    var phone = scope.querySelector('[data-phone]');
    var phoneErr = scope.querySelector('[data-phone-error]');
    if (phone) {
      var digits = (phone.value || '').replace(/\D/g, '');
      var badPhone = digits.length < 7;
      if (phoneErr) phoneErr.classList.toggle('show', badPhone);
      if (badPhone) { ok = false; focusEl = focusEl || phone; }
    }

    var upload = scope.querySelector('[data-up][data-required]');
    if (upload && imagesFor(upload).length === 0) {
      var upErr = upload.querySelector('[data-up-error]');
      if (upErr) upErr.classList.add('show');
      ok = false;
      focusEl = focusEl || upload;
    }

    if (!ok && focusEl) {
      if (focusEl.focus) focusEl.focus();
      focusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return ok;
  }

  /* Shared submit path for the popup and the contact page. */
  function submitSurvey(scope, opts) {
    opts = opts || {};
    var form = scope.querySelector('form');
    if (!form) return;
    collectSelections(scope);
    if (!validateContactBlock(scope)) return;

    var sheetUrl = (scope.dataset.sheetUrl || '').trim();
    var sendEmail = scope.dataset.sendEmail !== 'false';
    var upload = scope.querySelector('[data-up]');
    var images = upload ? imagesFor(upload) : [];

    var summary = scope.querySelector('[data-up-summary]');
    if (summary && images.length) {
      summary.value = images.length + ' image(s): ' + images.map(function (im) { return im.name; }).join(', ') +
        (sheetUrl ? ' — files in Google Drive, links in the sheet' : '');
    }

    var btn = opts.button || null;
    var finalize = function () {
      if (btn) { btn.disabled = false; btn.innerHTML = opts.buttonLabel || 'SUBMIT'; }
      if (!sheetUrl || sendEmail) {
        form.submit(); /* Shopify contact form → store email; the reload shows the stamp */
      } else if (opts.onDone) {
        opts.onDone();
      }
    };

    if (!sheetUrl) { finalize(); return; }

    var payload = payloadFromForm(form);
    var chanInput = scope.querySelector('[data-channel-value]');
    if (chanInput && chanInput.value) payload['Channel'] = chanInput.value;
    if (opts.channelFallback && !payload['Channel']) payload['Channel'] = opts.channelFallback;
    payload['Submitted From'] = window.location.href;
    if (images.length) {
      payload.images = images.map(function (im) {
        return { name: im.name, type: im.type, data: im.dataUrl.split(',')[1] };
      });
    }
    if (btn) { btn.disabled = true; btn.innerHTML = 'SENDING…'; }
    postToSheet(sheetUrl, payload).then(finalize);
  }

  /* Theme-editor webhook test */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hook-test]');
    if (!btn) return;
    var scope = btn.closest('[data-survey]');
    var msg = btn.parentElement.querySelector('[data-hook-msg]');
    var url = ((scope && scope.dataset.sheetUrl) || '').trim();
    if (!url) {
      if (msg) msg.textContent = 'Paste the webhook URL in this section\'s settings first.';
      return;
    }
    postToSheet(url, { 'Channel': 'Test', 'Test': 'Theme editor connection test' });
    if (msg) msg.textContent = 'Request sent. A row should appear on the "Tests" tab within a few seconds. If not, open the /exec URL in a new tab — it must show "SHK-RC connector OK", not a Google sign-in page.';
  });

  /* ================= DESIGN POPUP (multi-channel survey) ================= */
  var STEPS = ['channel', '1', '2', 'contact'];
  var modalStep = 'channel';
  var activeChannel = '';

  function modalEl() { return document.querySelector('[data-design-overlay]'); }

  /* Only the blocks tagged for the chosen channel (or "all") stay in play. */
  function applyChannel(overlay, channel) {
    activeChannel = channel || '';
    var value = '';
    overlay.querySelectorAll('[data-chan-pick]').forEach(function (btn) {
      var on = btn.dataset.chanPick === channel;
      btn.classList.toggle('sel', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) value = btn.dataset.chanLabel || channel;
    });
    var store = overlay.querySelector('[data-channel-value]');
    if (store) store.value = value;
    var flag = overlay.querySelector('[data-chan-flag]');
    if (flag) {
      flag.textContent = value || '';
      flag.style.display = value ? '' : 'none';
    }
    overlay.querySelectorAll('.q-block').forEach(function (block) {
      var scopeList = (block.dataset.chan || 'all').split(/\s+/);
      var visible = scopeList.indexOf('all') > -1 || scopeList.indexOf(channel) > -1;
      block.hidden = !visible;
      if (!visible) {
        block.querySelectorAll('input, textarea').forEach(function (f) { f.value = ''; });
        block.querySelectorAll('.sel').forEach(function (s) { s.classList.remove('sel'); });
      }
    });
  }

  function stepHasContent(overlay, step) {
    if (step === 'channel' || step === 'contact') return true;
    var el = overlay.querySelector('.q-step[data-step="' + step + '"]');
    if (!el) return false;
    return !!el.querySelector('.q-block:not([hidden])');
  }

  function nextStep(overlay, from, dir) {
    var i = STEPS.indexOf(from);
    if (i < 0) return from;
    for (var j = i + dir; j >= 0 && j < STEPS.length; j += dir) {
      if (stepHasContent(overlay, STEPS[j])) return STEPS[j];
    }
    return from;
  }

  function setStep(n) {
    var overlay = modalEl();
    if (!overlay) return;
    modalStep = n;
    overlay.querySelectorAll('.q-step').forEach(function (s) {
      s.classList.toggle('cur', s.dataset.step === String(n));
    });
    var idx = STEPS.indexOf(String(n));
    overlay.querySelectorAll('.gauge i').forEach(function (g, i) {
      g.classList.toggle('done', n === 'done' || i <= idx);
    });
    var nav = overlay.querySelector('[data-modal-nav]');
    if (!nav) return;
    if (n === 'done') { nav.style.display = 'none'; return; }
    nav.style.display = 'flex';
    var back = overlay.querySelector('[data-back]');
    var next = overlay.querySelector('[data-next]');
    if (back) back.style.visibility = n === 'channel' ? 'hidden' : 'visible';
    if (next) {
      next.disabled = n === 'channel' && !activeChannel;
      next.innerHTML = n === 'contact' ? 'SUBMIT' : 'NEXT';
    }
    overlay.querySelectorAll('.form-error').forEach(function (el) { el.classList.remove('show'); });
    var body = overlay.querySelector('.modal-body');
    if (body) body.scrollTop = 0;
  }

  function openModal(startStep, channel) {
    var overlay = modalEl();
    if (!overlay) return;
    overlay.classList.remove('open');
    void overlay.offsetWidth; /* restart snap-drop + charge bars */
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (channel) applyChannel(overlay, channel);
    setStep(startStep || (activeChannel ? '1' : 'channel'));
  }
  function closeModal() {
    var overlay = modalEl();
    if (!overlay) return;
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function resetModal(overlay) {
    var form = overlay.querySelector('form');
    if (form) form.reset();
    overlay.querySelectorAll('.sel').forEach(function (el) { el.classList.remove('sel'); });
    var upload = overlay.querySelector('[data-up]');
    if (upload) { imageStore.set(upload, []); renderPreviews(upload); }
    applyChannel(overlay, '');
  }

  function checkModalFormState() {
    var overlay = modalEl();
    if (!overlay) return;
    if (overlay.querySelector('[data-form-success]')) {
      openModal('done');
      setStep('done');
      if (!DESIGN && window.location.search) history.replaceState(null, '', window.location.pathname);
    } else if (overlay.querySelector('[data-form-failed]')) {
      openModal('contact');
      var err = overlay.querySelector('[data-email-error]');
      if (err) err.classList.add('show');
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-modal]');
    if (opener) {
      e.preventDefault();
      openModal(opener.dataset.channel ? '1' : 'channel', opener.dataset.channel || '');
      return;
    }
    if (e.target.closest('[data-close-modal]')) { closeModal(); return; }

    var overlay = modalEl();
    if (!overlay || !overlay.classList.contains('open')) return;
    if (e.target === overlay) { closeModal(); return; }
    if (!overlay.contains(e.target)) return;

    var pick = e.target.closest('[data-chan-pick]');
    if (pick) {
      applyChannel(overlay, pick.dataset.chanPick);
      var nx = overlay.querySelector('[data-next]');
      if (nx) nx.disabled = false;
      return;
    }
    if (e.target.closest('[data-back]')) { setStep(nextStep(overlay, String(modalStep), -1)); return; }
    if (e.target.closest('[data-next]')) {
      if (modalStep === 'contact') {
        submitSurvey(overlay, {
          button: overlay.querySelector('[data-next]'),
          buttonLabel: 'SUBMIT',
          channelFallback: 'Unspecified',
          onDone: function () { setStep('done'); resetModal(overlay); }
        });
      } else {
        setStep(nextStep(overlay, String(modalStep), 1));
      }
      return;
    }
    var group = e.target.closest('[data-q]');
    if (group) {
      var o = e.target.closest('.opt,.sw');
      if (!o) return;
      if (o.classList.contains('sel')) { o.classList.remove('sel'); return; }
      var multi = +group.dataset.multi || 1;
      var sel = group.querySelectorAll('.sel');
      if (multi === 1) sel.forEach(function (x) { x.classList.remove('sel'); });
      else if (sel.length >= multi) sel[0].classList.remove('sel');
      o.classList.add('sel');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal(); closeDrawer(); closeMenu(); }
  });

  checkModalFormState();
  prefillCodes();
  syncCodeProperty();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-design-overlay]')) {
      modalStep = 'channel';
      activeChannel = '';
      checkModalFormState();
    }
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-design-overlay]')) openModal('channel');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-design-overlay]')) closeModal();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var overlay = modalEl();
    if (!overlay || !overlay.contains(e.target)) return;
    var block = e.target.closest('.q-block');
    if (block && block.dataset.chan) {
      var first = block.dataset.chan.split(/\s+/)[0];
      applyChannel(overlay, first === 'all' ? (activeChannel || 'hood') : first);
    }
    var stepEl = e.target.closest('.q-step');
    openModal(stepEl ? stepEl.dataset.step : 'channel');
  });

  /* ================= CONTACT PAGE FORM ================= */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-inquiry-submit]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('[data-survey]');
    if (!scope) return;
    submitSurvey(scope, {
      button: btn,
      buttonLabel: btn.dataset.label || 'SEND INQUIRY',
      channelFallback: 'Contact Page',
      onDone: function () {
        var ok = scope.querySelector('[data-inquiry-done]');
        var form = scope.querySelector('form');
        if (ok) { ok.hidden = false; ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        if (form) form.style.display = 'none';
      }
    });
  });

  /* Channel chips on the contact form write into the same Channel field */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-inquiry-channel]');
    if (!chip) return;
    var scope = chip.closest('[data-survey]');
    if (!scope) return;
    scope.querySelectorAll('[data-inquiry-channel]').forEach(function (c) { c.classList.remove('sel'); });
    chip.classList.add('sel');
    var store = scope.querySelector('[data-channel-value]');
    if (store) store.value = chip.dataset.inquiryChannel;
  });

  /* ================= CART DRAWER ================= */
  var drawerContainer = document.getElementById('DrawerContainer');
  var drawerOpen = false;

  function drawerRoot() {
    return drawerContainer ? drawerContainer.querySelector('[data-drawer]') : null;
  }
  function openDrawer() {
    var root = drawerRoot();
    if (!root) return;
    drawerOpen = true;
    root.classList.remove('open');
    void root.offsetWidth;
    root.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var root = drawerRoot();
    if (!root || !drawerOpen) return;
    drawerOpen = false;
    root.classList.remove('open');
    document.body.style.overflow = '';
  }
  function updateCartCount() {
    var root = drawerRoot();
    if (!root) return;
    var count = parseInt(root.dataset.count || '0', 10);
    document.querySelectorAll('[data-drawer-open]').forEach(function (link) {
      var badge = link.querySelector('[data-cart-count]');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'count';
          badge.setAttribute('data-cart-count', '');
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }
  function refreshDrawer(openAfter) {
    return fetch(routes.root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (!drawerContainer) return;
        drawerContainer.innerHTML = html;
        updateCartCount();
        prefillCodes();
        if (openAfter || drawerOpen) openDrawer();
      });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener && drawerRoot()) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-change-line]');
    if (!btn) return;
    var root = drawerRoot();
    if (root) root.setAttribute('aria-busy', 'true');
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: parseInt(btn.dataset.line, 10),
        quantity: parseInt(btn.dataset.quantity, 10)
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshDrawer(true); })
      .catch(function () { window.location.href = routes.cart; });
  });

  /* Racer code saved as a cart attribute, then routed through Shopify's
     /discount/{code} endpoint so it also lands as a real discount. A code
     that matches no live discount is silently ignored by Shopify — there's
     no storefront way to validate one without an app. */
  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target.closest('[data-checkout-btn]');
    if (!checkoutBtn) return;
    var scope = checkoutBtn.closest('.drawer-foot') || checkoutBtn.closest('form');
    var input = scope ? scope.querySelector('[data-code-input]') : null;
    var code = input ? input.value.trim() : '';
    if (!code) return;
    e.preventDefault();
    checkoutBtn.disabled = true;
    fetch(routes.cartUpdate + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Racer Code': code } })
    })
      .catch(function () {})
      .then(function () {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-code-input]');
    if (!input) return;
    e.preventDefault();
    var scope = input.closest('.drawer-foot') || input.closest('form');
    var btn = scope ? scope.querySelector('[data-checkout-btn]') : null;
    if (btn) btn.click();
  });

  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-drawer]')) openDrawer();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-drawer]')) closeDrawer();
  });

  /* ================= ADD TO CART ================= */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var isProduct = form.classList.contains('product-form') || form.classList.contains('quick-add-form');
    if (!isProduct || !form.querySelector('[name="id"]')) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    var body = new FormData(form);
    if (String(body.get('properties[Racer Code]') || '').trim() === '') {
      body.delete('properties[Racer Code]');
    }

    fetch(routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw d; });
        return r.json();
      })
      .then(function () {
        fireToast('ADDED TO CART', 'カートに追加しました', '追');
        return refreshDrawer(true);
      })
      .catch(function (err) { alert((err && err.description) || 'Could not add to cart.'); })
      .then(function () { if (submitBtn) submitBtn.disabled = false; });
  });

  /* ================= PRODUCT: OPTION PILLS → VARIANT =================
     Printify products routinely carry 2–3 options and dozens of variants,
     which a single <select> handles badly. Pills pick option values; this
     resolves the matching variant, greys out combinations that don't exist,
     and swaps the gallery to the variant's own mockup. */
  function variantData(root) {
    var script = root.querySelector('[data-variant-json]');
    if (!script) return [];
    try { return JSON.parse(script.textContent); } catch (e) { return []; }
  }
  function currentSelections(root) {
    var sel = [];
    root.querySelectorAll('[data-opt-group]').forEach(function (group) {
      var chosen = group.querySelector('.pill.sel');
      sel[parseInt(group.dataset.optGroup, 10)] = chosen ? chosen.dataset.value : null;
    });
    return sel;
  }
  function findVariant(variants, sel) {
    return variants.filter(function (v) {
      return sel.every(function (val, i) { return val == null || v.options[i] === val; });
    })[0] || null;
  }
  function updateVariant(root) {
    var variants = variantData(root);
    if (!variants.length) return;
    var sel = currentSelections(root);

    /* Grey out values that can't combine with the other current choices */
    root.querySelectorAll('[data-opt-group]').forEach(function (group) {
      var idx = parseInt(group.dataset.optGroup, 10);
      group.querySelectorAll('.pill').forEach(function (pill) {
        var probe = sel.slice();
        probe[idx] = pill.dataset.value;
        var hit = variants.filter(function (v) {
          return probe.every(function (val, i) { return val == null || v.options[i] === val; });
        });
        var any = hit.some(function (v) { return v.available; });
        pill.classList.toggle('soldout', hit.length > 0 && !any);
        pill.disabled = hit.length === 0;
      });
    });

    var variant = findVariant(variants, sel);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var saleEl = root.querySelector('[data-sale]');
    var addBtn = root.querySelector('[data-add]');
    var stickyAdd = document.querySelector('[data-sticky-add]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var lowStock = root.querySelector('[data-low-stock]');

    if (!variant) {
      if (addBtn) { addBtn.disabled = true; addBtn.innerHTML = 'UNAVAILABLE'; }
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;
    if (stickyPrice) stickyPrice.textContent = variant.price;
    if (compareEl) {
      compareEl.textContent = variant.compare || '';
      compareEl.style.display = variant.compare ? '' : 'none';
    }
    if (saleEl) saleEl.style.display = variant.compare ? '' : 'none';
    [addBtn, stickyAdd].forEach(function (b) {
      if (!b) return;
      b.disabled = !variant.available;
      b.innerHTML = variant.available ? (b.dataset.addLabel || 'ADD TO CART') : 'SOLD OUT';
    });
    if (lowStock) {
      var threshold = parseInt(lowStock.dataset.threshold || '0', 10);
      var inv = variant.inventory;
      var show = threshold > 0 && typeof inv === 'number' && inv > 0 && inv <= threshold;
      lowStock.querySelectorAll('[data-stock-count]').forEach(function (el) { el.textContent = inv; });
      lowStock.style.display = show ? '' : 'none';
    }
    if (variant.image) {
      var main = root.querySelector('[data-main-image]');
      if (main) {
        main.src = variant.image;
        main.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('sel', t.dataset.thumb === variant.image);
      });
    }
    if (!DESIGN && variant.id && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-opt-group] .pill');
    if (!pill || pill.disabled) return;
    var group = pill.closest('[data-opt-group]');
    group.querySelectorAll('.pill').forEach(function (p) { p.classList.remove('sel'); });
    pill.classList.add('sel');
    var root = pill.closest('[data-variant-root]');
    if (root) updateVariant(root);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-thumb]');
    if (!btn) return;
    var root = btn.closest('[data-variant-root]') || document;
    var main = root.querySelector('[data-main-image]');
    if (!main) return;
    main.src = btn.dataset.thumb;
    main.removeAttribute('srcset');
    root.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('sel'); });
    btn.classList.add('sel');
  });

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.stepper');
    var input = wrap && wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    input.value = Math.max(1, v + (plus ? 1 : -1));
  });

  document.addEventListener('click', function (e) {
    var stickyAdd = e.target.closest('[data-sticky-add]');
    if (!stickyAdd || stickyAdd.disabled) return;
    var form = document.querySelector('form.product-form');
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });

  /* ================= CART PAGE: remove line ================= */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-page [data-remove-line]');
    if (!btn) return;
    var line = btn.closest('.cart-line');
    var qty = line && line.querySelector('input[name="updates[]"]');
    var form = btn.closest('form');
    if (qty && form) {
      qty.value = 0;
      form.submit();
    }
  });
})();
